import React from "react";
import { NakiStoreHomeSectionListTemplate } from "themes/administration/naki-store/pages";
import { NakiStoreHomeSectionListViewStore } from "administration/naki-store/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiStoreHomeSectionListViewStore(rootStore, componentProps),
    "nakiStoreHomeSectionListViewStore"
)
class NakiStoreHomeSectionList extends React.Component {
    render() {
        return <NakiStoreHomeSectionListTemplate {...this.props} />;
    }
}

export default NakiStoreHomeSectionList;
